@if (links) {
  <div class="email-list ag-pa-md">
    <h4>Permanent link</h4>
    <br />
    <h6>Press Copy button to copy the link</h6>
    <br />
    <div class="input-group">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="links"
        title="URL Link"
        placeholder="content will be copy after click the copy button"
      />
      <span class="input-group-btn">
        <button
          role="button"
          aria-label="Copy"
          class="btn btn-default"
          [class.btn-success]="isCopied1"
          type="button"
          ngxClipboard
          [cbContent]="links"
          (cbOnSuccess)="(isCopied1 === true); getLink()"
        >
          <span class="color-header-color">Copy</span>
        </button>
      </span>
    </div>
  </div>
}
